
/*
  Image Compare
*/
const initImageCompare = () => {
  document.onreadystatechange = () => {
    if (document.readyState === 'complete') {
      document.querySelectorAll('.image-compare-slider').forEach(slider => {
        new ImageCompare(slider, {
          controlColor: slider.dataset.controlColor,
          controlShadow: true,
          addCircle: slider.dataset.addCircle === 'true',
          addCircleBlur: false,
          showLabels: slider.dataset.showLabels === 'true',
          labelOptions: {
            before: slider.dataset.labelBefore,
            after: slider.dataset.labelAfter,
            onHover: slider.dataset.labelOnHover === 'true'
          },
          smoothing: slider.dataset.smoothing === 'true',
          smoothingAmount: Number(slider.dataset.smoothingAmount),
          hoverStart: slider.dataset.hoverStart === 'true',
          verticalMode: slider.dataset.verticalMode === 'true',
          startingPoint: Number(slider.dataset.startingPoint),
          fluidMode: false
        }).mount()
      })
    }
  }
}
initImageCompare()

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.image-compare-slider')) {
    initImageCompare()
  }
})